import { AuthenticationParameters } from 'msal';
import React from 'react';
import { AccessTokenResponse, IAccountInfo } from 'react-aad-msal';

export type AuthenticationContextValue = {
    accountInfo: IAccountInfo;
    logout: VoidFunction;
    getAccessToken: (parameters?: AuthenticationParameters | undefined) => Promise<AccessTokenResponse>;
    scopes: AccessTokenScopes;
};

export type AccessTokenScopes = {
    'licenses.read': string;
    'licenses.write': string;
    'licenseTypes.read': string;
    'forms.read': string;
    'inspections.read': string;
    'inspections.write': string;
    'violations.read': string;
    'violations.write': string;
    'violationCategories.read': string;
    'userProfiles.read': string;
    'inspectionTypes.read': string;
    'invoiceTypes.read': string;
    'feeTypes.read': string;
    'journalEntries.read': string;
    'journalEntries.write': string;
    'payments.write': string;
    'persons.read': string;
    'persons.write': string;
    'personTypes.read': string;
    'events.read': string;
    'events.write': string;
    'eventTypes.read': string;
    'mergeTemplates.read': string;
    'timesheets.read': string;
    'timesheets.write': string;
    'contactTypes.read': string;
    'workflows.read': string;
    'citations.read': string;
    'citations.write': string;
    'citationTypes.read': string;
    'applications.read': string;
    'applications.write': string;
};

export const AuthenticationContext = React.createContext<AuthenticationContextValue | undefined>(undefined);

AuthenticationContext.displayName = 'AuthenticationContext';
